import Api from './api';

const carrierCompaniesListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/carriers', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createCarrierCompanyRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/carriers/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const updateCarrierCompanyRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/carriers/' + data.id, data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteCarrierCompanyRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/carriers/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default {
    carrierCompaniesListRequest,
    createCarrierCompanyRequest,
    updateCarrierCompanyRequest,
    deleteCarrierCompanyRequest,
}



// WEBPACK FOOTER //
// ./src/api/apiCarrierCompanies.js